import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CartService } from "../../app/feutures/cart/services/cart.service";

import * as cartActions from '../cart/cart.actions';
import { map, mergeMap, catchError, switchMap, filter, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { cartResponse } from "../../app/shared/interface/cart";




@Injectable()
export class CartEffects {
    private _actions$ = inject(Actions);

    private cartService = inject(CartService);


//  load Cart

loadCart$ = createEffect(()=>
    this._actions$.pipe(
        ofType(cartActions.loadCart),
        mergeMap(()=>
            this.cartService.getCartData().pipe(
                map(res=>
                    cartActions.loadCartSuccess({cart: res.cart, numOfCartItems: res.numOfCartItems})
                )   
            )
        )
    )
);



// Add Product to Cart
addcartProduct$ =createEffect(()=>
this._actions$.pipe(
    ofType(cartActions.addCartProduct),
    mergeMap(action=>
        this.cartService.addToCartData(action.productId,action.quantity).pipe(
            map(res=>
                cartActions.addToCartSuccess({cart: res.cart, numOfCartItems: res.numOfCartItems})
            ),
            catchError(error => of(cartActions.addCartProductFailure({ productId: action.productId, error })))
        )
    )
)
);
// Remove Product from Cart


removecartProduct$ = createEffect(() =>
  this._actions$.pipe(
    ofType(cartActions.removeCartProduct),
    mergeMap(action =>
      this.cartService.removeFromCartData(action.productId).pipe(
        map(res =>
          cartActions.removeFromCartSuccess({
            cart: res.cart,
            numOfCartItems: res.numOfCartItems
          })
        ),
        catchError(error =>
          of(cartActions.removeCartProductFailure({ productId: action.productId, error }))
        )
      )
    )
  )
);

// Clear Cart
clearCart$ = createEffect(() =>
  this._actions$.pipe(
    ofType(cartActions.clearCart),
    exhaustMap(() =>
      this.cartService.clearCartData().pipe(
        map(() => cartActions.clearCartSuccess()),
        
      )
    )
  )
);

// Update Cart Item Quantity
updateQuantity$ = createEffect(() =>
  this._actions$.pipe(
    ofType(cartActions.updateQuantity),
    filter(({ quantity }) => quantity > 0),
    switchMap(({ productId, quantity }) =>
      this.cartService.UpdateCartData(productId, quantity).pipe(
        map((res: cartResponse) =>
          cartActions.loadCartSuccess({
            cart: res.cart,
            numOfCartItems: res.numOfCartItems
          })
        )
      )
    )
  )
);


// Validate Coupon  
validateCoupon$ = createEffect(() =>
  this._actions$.pipe(
    ofType(cartActions.validateCoupon),
    mergeMap(action =>    
      this.cartService.validateCartData(action.couponCode).pipe(
        map(response =>
          cartActions.validateCouponSuccess({ isValid: response.isValid })
        ),
      )
    )
  )
);
// Apply Coupon
applyCoupon$ = createEffect(() =>
  this._actions$.pipe(
    ofType(cartActions.applyCoupon),
    mergeMap(action =>
      this.cartService.applyCouponData(action.couponCode).pipe(
        map(res =>
          cartActions.loadCartSuccess({ cart: res.cart, numOfCartItems: res.numOfCartItems })
        ),
      )
    )
  )
);  


}